import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanDeactivate, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';

export interface CanComponentDeactivate {
  canDeactivate: () => boolean | Observable<boolean>;
}

const SERVICE_SEGMENT_PATTERN = /pakalpojumi\/[^/]+/;

const serviceSegment = (url: string): string | null => url.split('?')[0].match(SERVICE_SEGMENT_PATTERN)?.[0] ?? null;

const isEnteringCreatedDraft = (currentUrl: string, nextUrl: string): boolean => {
  const current = currentUrl.split('?')[0];
  const currentService = serviceSegment(current);

  return !!currentService && currentService === serviceSegment(nextUrl) && current.endsWith(currentService);
};

@Injectable({ providedIn: 'root' })
export class UnsavedChangesGuard implements CanDeactivate<CanComponentDeactivate> {
  canDeactivate(
    component: CanComponentDeactivate,
    currentRoute: ActivatedRouteSnapshot,
    currentState: RouterStateSnapshot,
    nextState?: RouterStateSnapshot
  ): boolean | Observable<boolean> {
    if (nextState && isEnteringCreatedDraft(currentState.url, nextState.url)) {
      return true;
    }

    return component.canDeactivate ? component.canDeactivate() : true;
  }
}
